// Safari doesn't respect the 'no-cache' headers and when you click 'back' it actually serves a cached version.
// Force a reload when the page is loaded from the back-forward cache.
// See: https://stackoverflow.com/questions/8788802/prevent-safari-loading-from-cache-when-back-button-is-clicked

window.onpageshow = function (event) {
  if (event.persisted) {
    window.location.reload();
  }
};
